
import { mapGetters } from "vuex";
export default {
    name: "Announcement",
    data: () => ({
        newsPagination: 1,
        paginationSelected: 1,
        categorySelectId: "",
    }),
    head: {
        title: "News&Announcements",
        htmlAttrs: {
            lang: "en",
        },
        meta: [
            { charset: "utf-8" },
            {
                name: "viewport",
                content: "width=device-width, initial-scale=1",
            },
            {
                hid: "description",
                name: "description",
                content: `News And Announcements page of LOGC is reprecent about all articles, news and announcements of Laos off-shore gaming control corporation`,
            },
            { name: "format-detection", content: "telephone=no" },
        ],
    },
    computed: {
        ...mapGetters({
            categories: "news/categories",
            news: "news/news",
            loading: "news/loading",
        }),
        fromItem() {
            const pageEndItem = this.newsPagination * 10;
            return this.news?.total > 0 ? pageEndItem - 10 + 1 : 0;
        },
        toItem() {
            const pageEndItem = this.newsPagination * 10;
            return pageEndItem > this.news?.total
                ? this.news?.total
                : pageEndItem;
        },
        paginationLength() {
            return (this.news?.total || 1) % 10 === 0
                ? (this.news?.total || 1) % 10
                : Math.floor((this.news?.total || 1) / 10) + 1;
        },
    },
    mounted() {
        this.$store.dispatch("news/getNews", 1);
        this.$store.dispatch("news/getCategory");
    },
    methods: {
        changeNewsByCategory(categoryId) {
            if (this.categorySelectId !== categoryId) {
                this.categorySelectId = categoryId;
                if (categoryId) {
                    this.$store.dispatch("news/getNewsByCategory", {
                        pageNo: 1,
                        categoryId: this.categorySelectId,
                    });
                } else {
                    this.$store.dispatch("news/getNews", 1);
                }
            }
        },
        paginationChange() {
            if (this.newsPagination !== this.paginationSelected) {
                this.paginationSelected = this.newsPagination;
                if (this.categorySelectId) {
                    this.$store.dispatch("news/getNewsByCategory", {
                        pageNo: this.newsPagination,
                        categoryId: this.categorySelectId,
                    });
                } else {
                    this.$store.dispatch("news/getNews", this.newsPagination);
                }
            }
        },
    },
};
